/**
 * Generated by orval v7.21.0 🍺
 * Do not edit manually.
 * OpenAPI definition
 * OpenAPI spec version: v0
 */
import type {
  AddToFolderRequest,
  AddTouchpointToFolderPathParameters,
  AddTouchpointsToFolderFromTemplatesPathParameters,
  AddTouchpointsToFolderRequest,
  CampaignFolderCreateRequest,
  CampaignFolderDTO,
  CampaignFolderUpdateRequest,
  CreateFolderFromMondayTemplateRequest,
  CreateFolderPathParameters,
  CreateFoldersFromMondayTemplatesPathParameters,
  DeleteFolderPathParameters,
  GetFoldersParams,
  GetFoldersPathParameters,
  GetOneFolderPathParameters,
  PagedModelCampaignFolderDTO,
  RemoveTouchpointFromFolderPathParameters,
  TouchpointDTO,
  UpdateFolderPathParameters,
} from "../schemas";

import { customInstance } from "../../config/mutator";

export const getCampaignFolder = () => {
  /**
 * Get folder for a campaign

Required authority: PERM_CAMPAIGN_READ
 */
  const getOneFolder = ({ clientId, campaignId, id }: GetOneFolderPathParameters) => {
    return customInstance<CampaignFolderDTO>({
      url: `/api/clients/${clientId}/campaigns/${campaignId}/folders/${id}`,
      method: "GET",
    });
  };
  /**
 * Update a folder for a campaign

Required authority: PERM_CAMPAIGN_WRITE
 */
  const updateFolder = (
    { clientId, campaignId, id }: UpdateFolderPathParameters,
    campaignFolderUpdateRequest: CampaignFolderUpdateRequest,
  ) => {
    return customInstance<CampaignFolderDTO>({
      url: `/api/clients/${clientId}/campaigns/${campaignId}/folders/${id}`,
      method: "PUT",
      headers: { "Content-Type": "application/json" },
      data: campaignFolderUpdateRequest,
    });
  };
  /**
 * Delete a folder for a campaign

Required authority: PERM_CAMPAIGN_WRITE
 */
  const deleteFolder = ({ clientId, campaignId, id }: DeleteFolderPathParameters) => {
    return customInstance<void>({
      url: `/api/clients/${clientId}/campaigns/${campaignId}/folders/${id}`,
      method: "DELETE",
    });
  };
  /**
 * Get all folders for a campaign

Required authority: PERM_CAMPAIGN_READ
 */
  const getFolders = (
    { clientId, campaignId }: GetFoldersPathParameters,
    params?: GetFoldersParams,
  ) => {
    return customInstance<PagedModelCampaignFolderDTO>({
      url: `/api/clients/${clientId}/campaigns/${campaignId}/folders`,
      method: "GET",
      params,
    });
  };
  /**
 * Create a folder for a campaign

Required authority: PERM_CAMPAIGN_WRITE
 */
  const createFolder = (
    { clientId, campaignId }: CreateFolderPathParameters,
    campaignFolderCreateRequest: CampaignFolderCreateRequest,
  ) => {
    return customInstance<CampaignFolderDTO>({
      url: `/api/clients/${clientId}/campaigns/${campaignId}/folders`,
      method: "POST",
      headers: { "Content-Type": "application/json" },
      data: campaignFolderCreateRequest,
    });
  };
  /**
 * Assign a touchpoint to a folder

Required authority: PERM_CAMPAIGN_WRITE
 */
  const addTouchpointToFolder = (
    { clientId, campaignId, id }: AddTouchpointToFolderPathParameters,
    addToFolderRequest: AddToFolderRequest,
  ) => {
    return customInstance<TouchpointDTO>({
      url: `/api/clients/${clientId}/campaigns/${campaignId}/folders/${id}/touchpoints`,
      method: "POST",
      headers: { "Content-Type": "application/json" },
      data: addToFolderRequest,
    });
  };
  /**
 * Add touchpoints to an existing folder from Monday.com templates

Required authority: PERM_CAMPAIGN_WRITE
 */
  const addTouchpointsToFolderFromTemplates = (
    { clientId, campaignId, folderId }: AddTouchpointsToFolderFromTemplatesPathParameters,
    addTouchpointsToFolderRequest: AddTouchpointsToFolderRequest,
  ) => {
    return customInstance<TouchpointDTO[]>({
      url: `/api/clients/${clientId}/campaigns/${campaignId}/folders/${folderId}/touchpoints/from-monday-template`,
      method: "POST",
      headers: { "Content-Type": "application/json" },
      data: addTouchpointsToFolderRequest,
    });
  };
  /**
 * Create folders from Monday.com templates, processing each template through Monday.com and creating touchpoints

Required authority: PERM_CAMPAIGN_WRITE
 */
  const createFoldersFromMondayTemplates = (
    { clientId, campaignId }: CreateFoldersFromMondayTemplatesPathParameters,
    createFolderFromMondayTemplateRequest: CreateFolderFromMondayTemplateRequest,
  ) => {
    return customInstance<CampaignFolderDTO[]>({
      url: `/api/clients/${clientId}/campaigns/${campaignId}/folders/from-monday-template`,
      method: "POST",
      headers: { "Content-Type": "application/json" },
      data: createFolderFromMondayTemplateRequest,
    });
  };
  /**
 * Remove a touchpoint from a folder

Required authority: PERM_CAMPAIGN_WRITE
 */
  const removeTouchpointFromFolder = ({
    clientId,
    campaignId,
    id,
    touchpointId,
  }: RemoveTouchpointFromFolderPathParameters) => {
    return customInstance<void>({
      url: `/api/clients/${clientId}/campaigns/${campaignId}/folders/${id}/touchpoints/${touchpointId}`,
      method: "DELETE",
    });
  };
  return {
    getOneFolder,
    updateFolder,
    deleteFolder,
    getFolders,
    createFolder,
    addTouchpointToFolder,
    addTouchpointsToFolderFromTemplates,
    createFoldersFromMondayTemplates,
    removeTouchpointFromFolder,
  };
};
export type GetOneFolderResult = NonNullable<
  Awaited<ReturnType<ReturnType<typeof getCampaignFolder>["getOneFolder"]>>
>;
export type UpdateFolderResult = NonNullable<
  Awaited<ReturnType<ReturnType<typeof getCampaignFolder>["updateFolder"]>>
>;
export type DeleteFolderResult = NonNullable<
  Awaited<ReturnType<ReturnType<typeof getCampaignFolder>["deleteFolder"]>>
>;
export type GetFoldersResult = NonNullable<
  Awaited<ReturnType<ReturnType<typeof getCampaignFolder>["getFolders"]>>
>;
export type CreateFolderResult = NonNullable<
  Awaited<ReturnType<ReturnType<typeof getCampaignFolder>["createFolder"]>>
>;
export type AddTouchpointToFolderResult = NonNullable<
  Awaited<ReturnType<ReturnType<typeof getCampaignFolder>["addTouchpointToFolder"]>>
>;
export type AddTouchpointsToFolderFromTemplatesResult = NonNullable<
  Awaited<ReturnType<ReturnType<typeof getCampaignFolder>["addTouchpointsToFolderFromTemplates"]>>
>;
export type CreateFoldersFromMondayTemplatesResult = NonNullable<
  Awaited<ReturnType<ReturnType<typeof getCampaignFolder>["createFoldersFromMondayTemplates"]>>
>;
export type RemoveTouchpointFromFolderResult = NonNullable<
  Awaited<ReturnType<ReturnType<typeof getCampaignFolder>["removeTouchpointFromFolder"]>>
>;
